<!-- @format -->

<template>
	<el-collapse :id="item.options.code" :model-value="activeNames" class="collapse">
		<el-collapse-item name="1">
			<template #title>
				<div class="collapse-title">
					<span class="collapse-title-label">
						{{ item.options.label }}
						<template v-if="item.options.Attrtypesign === '2'">
							<svg-icon name="table" class="form-item-content-icon" />
						</template>
					</span>
					<slot name="footer"></slot>
				</div>
			</template>
			<!-- 如果没有数据 -->
			<div v-if="!item.children.length">not content</div>

			<!-- 如果为多例则展示成列表 -->
			<template v-if="type === 'render' && item.options.Attrtypesign === '2'">
				<Table v-model="value" :item="item" v-bind="$attrs"></Table>
			</template>

			<!-- 否则展示正常数据，即为插槽 -->
			<template v-else>
				<slot></slot>
			</template>
		</el-collapse-item>
	</el-collapse>
</template>

<script setup lang="ts">
	import Table from './table.vue';

	// props
	interface Props {
		modelValue: any;
		item: any;
		type?: 'render' | 'drag';
	}
	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue']);

	// state
	const activeNames = ref(['1']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped lang="scss">
	.collapse {
		width: 100%;
		margin-top: 5px;

		.collapse-title {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.collapse-title-label {
				display: flex;
				align-items: center;
				font-weight: bold;

				.form-item-content-icon {
					font-size: 16px;
					margin-left: 5px;
				}
			}
		}
	}
</style>
